function createWrapper (t, d, r) {
  const wrapper = {
    func: t,
    delay: d,
    resolve: r
  }

  function callWrapper () {
    wrapper.call()
  }

  wrapper.delayedCall = function () {
    setTimeout(callWrapper, this.delay)
  }

  wrapper.call = function () {
    const result = this.func()
    if (result.end) {
      this.resolve(result.final)
    } else {
      this.delayedCall()
    }
  }
  return wrapper
}

export default function (t, d) {
  return new Promise(
    resolve => {
      const wrapper = createWrapper(t, d, resolve)
      wrapper.delayedCall()
    }
  )
}
